import { render, staticRenderFns } from "./SanifairLogs.vue?vue&type=template&id=1c610cbc"
import script from "./SanifairLogs.vue?vue&type=script&lang=ts"
export * from "./SanifairLogs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports